/**
 * Compare pages — EDIT THIS FILE for copy.
 * Be honest. Do not invent features or trash competitors with fake claims.
 */

export const landIdCompare = {
  path: '/compare/land-id',
  competitorName: 'Land id',
  seoTitle: 'Community View vs Land id — Parcel Maps & Property Tours for Agents',
  seoDescription:
    'Comparing Community View and Land id for real estate agents: parcel search, ownership details, listing maps, property tours, embeds, and pricing simplicity.',
  h1: 'Community View vs Land id',
  lede:
    'Both help agents work with parcels and maps. The better fit depends on whether you want a broad land platform or a focused agent workflow for search, listing maps, and buyer-ready tours.',
  whenCommunityView: [
    'You want nationwide parcel search plus ownership details in a simple agent workflow',
    'Listing maps and cinematic property tours are central to how you market',
    'You want share links and website embeds buyers can open without friction',
    'You prefer straightforward agent pricing and a fast path from research to a sendable deliverable',
  ],
  whenLandId: [
    'You need a very deep layer catalog and land-project tooling across many specialties',
    'Your team already lives in Land id for portfolios, reports, or heavier due diligence workflows',
    'You specifically need Land id features CommunityView does not emphasize the same way',
  ],
  rows: [
    {
      label: 'Primary focus',
      communityView: 'Agent workflow: research → listing map / tour → share or embed',
      competitor: 'Broad land platform for agents, investors, developers, and landowners',
    },
    {
      label: 'Parcel search',
      communityView: 'Nationwide search by owner, address, or parcel ID with county filters',
      competitor: 'Strong parcel search and ownership exploration',
    },
    {
      label: 'Ownership details',
      communityView: 'Click-parcel ownership and assessor-style details on the map',
      competitor: 'Extensive parcel/ownership data surfaces',
    },
    {
      label: 'Map layers',
      communityView: 'Ownership, soils, wetlands, wildfire, public land, boundaries, and more',
      competitor: 'Very large overlay catalog (40+ layers positioned in their marketing)',
    },
    {
      label: 'Listing maps',
      communityView: 'Build annotated listing maps with share links and export',
      competitor: 'Custom map creation and sharing on paid plans',
    },
    {
      label: 'Property tours',
      communityView: 'Slide-based tours with orbit/amenities and agent branding',
      competitor: 'Shareable property tours / property stories',
    },
    {
      label: 'Website embeds',
      communityView: 'iframe embed for shared listing maps',
      competitor: 'Embeds available on higher tiers',
    },
    {
      label: 'Best for',
      communityView: 'Agents who want research and buyer-facing maps/tours in one place',
      competitor: 'Users who want a wide land-intelligence platform and project tooling',
    },
  ],
  closingTitle: 'Try CommunityView on a live listing',
  closingBody:
    'If your day-to-day is find the parcel, understand it, then send a map or tour buyers will open — start a trial and judge it on your next listing.',
};
